import { Grid } from '@mui/material';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Residence } from 'front-office/view-models/release-id-card/residence';

interface FormProps {
  onChange: (key: keyof Residence, value: Residence[keyof Residence]) => void;
  values?: Residence;
  disabled?: boolean;
}

const ForeignLocationComponent = ({
  disabled,
  values,
  onChange,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12}>
        <PmiTitleDivider>Località estera</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="locationForeign"
          name="locationForeign"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.locationForeign || ''}
          onChange={(event) => {
            onChange('locationForeign', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="provinceForeign"
          name="provinceForeign"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.provinceForeign || ''}
          onChange={(event) => {
            onChange('provinceForeign', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Stato"
          label="Stato"
          id="state"
          name="state"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.state || ''}
          onChange={(event) => {
            onChange('state', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="CAP"
          label="CAP"
          id="capForeign"
          name="capForeign"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.capForeign || ''}
          onChange={(event) => {
            onChange('capForeign', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          aria-label="Denominazione Toponimo"
          label="Denominazione Toponimo"
          id="nameForeign"
          name="nameForeign"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.nameForeign || ''}
          onChange={(event) => {
            onChange('nameForeign', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Numero civico"
          label="Numero civico"
          id="civicNumber"
          name="civicNumber"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.civicNumber || ''}
          onChange={(event) => {
            onChange('civicNumber', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Codice consolato"
          label="Codice consolato"
          id="consulateCode"
          name="consulateCode"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.consulateCode || ''}
          onChange={(event) => {
            onChange('consulateCode', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          aria-label="Consolato"
          label="Consolato"
          id="consulate"
          name="consulate"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.consulate || ''}
          onChange={(event) => {
            onChange('consulate', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

ForeignLocationComponent.displayName = 'Foreign location residence';

const ForeignLocation = memo(ForeignLocationComponent);

export default ForeignLocation;
